var _defs, _rect, _g, _path, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaberintoPremium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "wallGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#38BDF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2563EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGrad",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1E293B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0F172A"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "glow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "blur",
    operator: "over"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 16,
    fill: "url(#bgGrad)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "url(#wallGrad)",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    filter: "url(#glow)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "       M 16 34 L 16 88 A 8 8 0 0 0 24 96 L 88 96 A 8 8 0 0 0 96 88 L 96 74       M 96 58 L 96 24 A 8 8 0 0 0 88 16 L 24 16 A 8 8 0 0 0 16 24 L 16 18     "
  }), /*#__PURE__*/React.createElement("path", {
    d: "       M 36 16 L 36 76       M 56 16 L 56 36       M 56 56 L 56 96       M 76 16 L 76 56       M 76 76 L 76 96       M 36 36 L 56 36       M 76 36 L 96 36       M 76 56 L 96 56       M 56 76 L 96 76     "
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 6 26 L 26 26 L 26 86 L 46 86 L 46 46 L 66 46 L 66 66 L 86 66 L 106 66",
    stroke: "#F59E0B",
    strokeWidth: 3,
    strokeDasharray: "4, 4",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 26,
    r: 4,
    fill: "#10B981"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 102,
    cy: 66,
    r: 4,
    fill: "#F59E0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaberintoPremium);
export default __webpack_public_path__ + "static/media/laberinto_premium.148717fb56e161ca562ef5175e082cae.svg";
export { ForwardRef as ReactComponent };